module.exports = __webpack_public_path__ + "img/hr-assembling-machine-2-pipe-N.08820bcb.png";